import React from "react";
import { LoudarLogo } from "./LoudarLogo";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] bg-loudar-ink"
    >
      <div className="container-loudar py-16">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
          <div className="max-w-md">
            <div className="flex items-center">
              <LoudarLogo className="h-6 text-white" />
              <sup
                className="ml-1 text-white/70 text-[10px] font-semibold tracking-normal select-none"
                aria-label="registered trademark"
              >
                ®
              </sup>
            </div>
            <p className="mt-5 text-sm text-white/55">
              The professional identity layer for the music industry. Reputation, finally
              organised.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
            <div>
              <div className="label-chrome">Product</div>
              <ul className="mt-4 space-y-2">
                {[
                  ["Mission", "/#mission"],
                  ["Features", "/features"],
                  ["Industry", "/#industry"],
                ].map(([t, h]) => (
                  <li key={t}>
                    <a
                      href={h}
                      className="text-sm text-white/65 hover:text-white"
                      data-testid={`footer-link-${t.toLowerCase()}`}
                    >
                      {t}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="label-chrome">Access</div>
              <ul className="mt-4 space-y-2">
                <li>
                  <a
                    href="/pilot"
                    className="text-sm text-white/65 hover:text-white"
                    data-testid="footer-link-pilot"
                  >
                    Waiting List
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:hello@loudar.co.uk"
                    className="text-sm text-white/65 hover:text-white"
                    data-testid="footer-link-contact"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="label-chrome">Legal</div>
              <ul className="mt-4 space-y-2">
                <li>
                  <a href="/terms" className="text-sm text-white/65 hover:text-white" data-testid="footer-link-terms">
                    Terms
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom credits row */}
      <div className="container-loudar flex flex-col items-start justify-between gap-3 border-t border-white/[0.06] py-6 text-xs text-white/40 sm:flex-row">
        <span>© {new Date().getFullYear()} Loudar®. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.22em]">
          Built for the people behind the music.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
